import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/authcontext";

export default function ProtectedRoute({ children }) {
  const { user, userData, loading } = useAuth();
  const location = useLocation();
 
  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
 
  // Redirect to login if not authenticated OR if no Firestore doc exists (partial registration)
  if (!user || !userData) {
    // Save the attempted location for redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render the protected content
  return children;
}
